import(/* webpackMode: "eager" */ "/app/apps/student/src/app/error.tsx");
